import React from "react";
import PropTypes from "prop-types";

class CustomFieldsAccordion extends React.Component {
  state = {
    open: false
  };

  get customFieldsIsArray() {
    return Array.isArray(this.props.customFields);
  }

  otherProductDetails() {
    if (!this.state.open) {
      return { display: "none" };
    }
    return undefined;
  }

  toggleAccordion() {
    this.setState((prevState) => ({ open: !prevState.open }));
  }

  renderCustomFieldTableRow(start, key, value) {
    return (
      <tr
        key={key}
        className={`j-custom-field s-custom-field ${
          start === 0 ? "" : this.otherProductDetails()
        }`}
      >
        <td className="col-xs-4">{key}</td>
        <td className="col-xs-8"> {value} </td>
      </tr>
    );
  }

  renderCustomFieldTableRows(start, end) {
    let count = 0;
    const { customFields } = this.props;

    return Object.keys(customFields).map((key) => {
      const value = customFields[key];
      count += 1;

      if (start < count && count <= end) {
        return this.renderCustomFieldTableRow(start, key, value);
      }
      return undefined;
    });
  }

  renderAdditional() {
    const { count, customFields } = this.props;
    const additionalLength = Object.keys(customFields).length;

    if (this.state.open) {
      return this.renderCustomFieldTableRows(
        count,
        additionalLength
      );
    }
    return undefined;
  }

  renderDropdownButton() {
    const { customFields } = this.props;
    const text = this.state.open ? t("Hide Some Fields") : t("Show All Fields");

    if (Object.keys(customFields).length > this.props.count) {
      return (
        <tr
          className="s-hidden-fields"
          onClick={this.toggleAccordion.bind(this)}
        >
          <td colSpan="2">
            {text}
            <span
              aria-hidden="true"
              className={`bff-dropdown-carrot ${
                this.state.open ? "reverse" : ""
              }`}
            />
          </td>
        </tr>
      );
    }
    return undefined;
  }

  render() {
    const { count } = this.props;
    return (
      <React.Fragment>
        <table className="table s-custom-fields-section">
          <tbody>
            {this.renderCustomFieldTableRows(0, count)}
            {this.renderAdditional()}
            {this.renderDropdownButton()}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default CustomFieldsAccordion;

CustomFieldsAccordion.propTypes = {
  count: PropTypes.number.isRequired,
  customFields: PropTypes.shape({}).isRequired,
};
